import { PageProps } from 'gatsby'

const BulkPage = (props: PageProps): JSX.Element => {
  return (
    <>
      <div>Bulk</div>
    </>
  )
}

export default BulkPage
